import { IChildrenProps } from 'types/ChildrenProps';
import GustoMiddleware from './GustoMiddleware';

export default function AuthenticationDependentMiddleware({ children }: IChildrenProps) {
  return <GustoMiddleware>{children}</GustoMiddleware>;
}
